import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["accessibilityLabel", "appearance", "as", "circular", "color", "disabled", "icon", "name", "onClick", "size"];
import React, { forwardRef } from 'react';
import cx from 'classnames';
import system, { getColor } from '../../system';
import Base from '../Base';
import Screenreader from '../Screenreader';
import Icon from '../Icon';
import styles from './index.module.scss';
var SYSTEM_PROPS = ['flexProps', 'marginProps', 'floatProps', 'positioningProps'];
var IconButton = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _classnames;

  var accessibilityLabel = _ref.accessibilityLabel,
      appearance = _ref.appearance,
      as = _ref.as,
      circular = _ref.circular,
      color = _ref.color,
      disabled = _ref.disabled,
      icon = _ref.icon,
      name = _ref.name,
      onClick = _ref.onClick,
      size = _ref.size,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  var _getColor = getColor(color),
      colorSystemStyle = _getColor[1]; // Only use color with appearance `default`


  var colorStyle = appearance === 'default' ? colorSystemStyle : undefined;

  var _system = system(props, SYSTEM_PROPS),
      className = _system[0],
      style = _system[1],
      rest = _system[2];

  var classnames = (_classnames = {}, _classnames[styles.root] = true, _classnames[styles.small] = size === 'small', _classnames[styles.large] = size === 'large', _classnames[styles.default] = appearance === 'default', _classnames[styles.primary] = appearance === 'primary', _classnames[styles.secondary] = appearance === 'secondary', _classnames[styles.plain] = appearance === 'plain', _classnames[styles.outline] = appearance === 'outline', _classnames[styles.disabled] = disabled, _classnames[styles.square] = !circular, _classnames[styles.circular] = circular, _classnames); // TODO: remove when name is being removed from icon

  var iconProps = name ? {
    name: name
  } : {
    as: icon
  };

  if (name) {
    // eslint-disable-next-line
    console.warn('[DEPRECATED](IconButton): "name" is deprecated. Use the "icon" prop instead.');
  }

  return /*#__PURE__*/React.createElement(Base, _extends({
    as: as,
    className: cx(classnames, className),
    style: _extends({
      color: colorStyle
    }, style),
    disabled: disabled,
    ref: ref,
    onClick: onClick
  }, rest), /*#__PURE__*/React.createElement(Icon, _extends({
    "aria-hidden": "true"
  }, iconProps, {
    size: "small"
  })), accessibilityLabel || name ? /*#__PURE__*/React.createElement(Screenreader, null, accessibilityLabel || name) : null);
});
IconButton.displayName = 'IconButton';
IconButton.identifier = IconButton.displayName; // used in docs website

IconButton.clonableProps = SYSTEM_PROPS;
IconButton.defaultProps = {
  appearance: 'default',
  as: 'button',
  size: 'large',
  flexShrink: 0
};
export default IconButton;